// extracted by mini-css-extract-plugin
module.exports = {"path":"Path_path__68cbC","row":"Path_row__1rTfA","module":"Path_module__BuEWF","partner":"Path_partner__3V7PA"};